/**
 * Early Console Override - ALL BROWSER LOGGING SILENCED
 *
 * Console logging is DISABLED for production.
 * Set DISABLE_CONSOLE_LOGGING = false to enable logs for debugging.
 */

const DISABLE_CONSOLE_LOGGING = true // DISABLED FOR PRODUCTION

// Store original console methods for reference
const originalConsole = {
  log: console.log,
  info: console.info,
  warn: console.warn,
  error: console.error,
  debug: console.debug,
  trace: console.trace,
  table: console.table,
  group: console.group,
  groupEnd: console.groupEnd,
  groupCollapsed: console.groupCollapsed,
  dir: console.dir,
  dirxml: console.dirxml,
  assert: console.assert,
  time: console.time,
  timeEnd: console.timeEnd,
  count: console.count,
  clear: console.clear
}

// Save to window for reference
;(window as any).__ORIGINAL_CONSOLE__ = originalConsole

if (DISABLE_CONSOLE_LOGGING) {
  // Silent noop function
  const noop = () => {}

  // Override all console methods with silent noops
  console.log = noop
  console.info = noop
  console.warn = noop
  console.error = noop
  console.debug = noop
  console.trace = noop
  console.table = noop
  console.group = noop
  console.groupEnd = noop
  console.groupCollapsed = noop
  console.dir = noop
  console.dirxml = noop
  console.assert = noop
  console.time = noop
  console.timeEnd = noop
  console.count = noop
  console.clear = noop

  // Mark console as silenced
  ;(window as any).__consoleSilenced = true
} else {
  // Console logging is enabled
  ;(window as any).__consoleSilenced = false
}

// Mark console as checked
;(window as any).__consoleOverridden = true

export default true
